export default __webpack_public_path__ + "static/media/E-commerceLAB_1200x675-20.95b25a71.png";